'use strict';

function ctrl($q, $location, $window) {
    return {
        request: function (config) {
            config.headers = config.headers || {};
            if ($window.sessionStorage.token) {
                config.headers.Authorization = 'Bearer ' + $window.sessionStorage.token;
            }
            return config;
        },
        response: function (response) {
            if ((response.status === 401) || (response.status === 500)) {
                $location.url('/login');
            }
            return response || $q.when(response);
        }
    };
}

ctrl.$inject = ['$q', '$location', '$window'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/system/services/interceptor.js
 **/